import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var IsObjectPipe = (function () {
    function IsObjectPipe() {
    }
    IsObjectPipe.prototype.transform = function (input) {
        return isObject(input);
    };
    IsObjectPipe.decorators = [
        { type: Pipe, args: [{ name: 'isObject' },] },
    ];
    /** @nocollapse */
    IsObjectPipe.ctorParameters = function () { return []; };
    return IsObjectPipe;
}());
export { IsObjectPipe };
//# sourceMappingURL=is-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-object.js
// module id = 253
// module chunks = 4